var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.variants),function(groupedVariants){return [_vm._l((groupedVariants),function(variant,key){return [(key === 0)?_c('ax-attributes-variant-color',{attrs:{"policies":_vm.policies,"variantColor":variant.color}}):_vm._e(),_vm._v(" "),_c('ax-attributes-variant-size',{attrs:{"policies":_vm.policies,"variant":variant}})]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }